import type { ConsentKind, ConsentRecord } from '@salonomy/types';

/** Human labels for the consent kinds (the enum order matches the API). */
export const CONSENT_KIND_LABEL: Record<ConsentKind, string> = {
  consultation: 'Consultation',
  patch_test: 'Patch test',
  allergy: 'Allergy declaration',
  waiver: 'Waiver',
  marketing: 'Marketing',
  other: 'Other',
};

export const CONSENT_KINDS: ConsentKind[] = [
  'consultation',
  'patch_test',
  'allergy',
  'waiver',
  'marketing',
  'other',
];

export type RecordValidity = 'valid' | 'expired' | null;

/**
 * Validity of a captured record, DERIVED from the server's `validUntil` (set for a dated record like a
 * patch test). We never invent a window here — a record with no `validUntil` is simply undated (null), and
 * one whose `validUntil` is in the past is 'expired'. `validUntil` is an IsoDate (YYYY-MM-DD); compare at
 * the start of that UTC day so "today" still reads as valid.
 */
export function recordValidity(record: Pick<ConsentRecord, 'validUntil'>): RecordValidity {
  if (!record.validUntil) return null;
  const until = new Date(`${record.validUntil}T00:00:00Z`).getTime();
  return until >= startOfTodayUtc() ? 'valid' : 'expired';
}

function startOfTodayUtc(): number {
  const now = new Date();
  return Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
}
